import { Alert, Stack } from '@mui/material';
import ExpSnackbarAlerts from '../../../../../shared/components/display/ExpSnackbarAlerts';
import DoubleConfirmModal from '../../../../../shared/components/modals/DoubleConfirmModal';
import ShipmentHistoryModal from '../components/voyage/ShipmentHistoryModal';
import VoyageHistoryModal from '../components/voyage/VoyageHistoryModal';
import AddShipModal from '../modals/AddShipModal';
import GroupEditModal from '../modals/VoyageGroupEditModal';

const VesselSalesModals = ({
  snackbarOpen,
  snackbarMessage,
  snackbarSeverity,
  onSnackbarClose,
  openEditDialog,
  vesselFormMode,
  editVoyageRow,
  onCloseEditDialog,
  setSnackbarMessage,
  setSnackbarOpen,
  setSnackbarSeverity,
  isDoubleConfirmModalOpen,
  rowData,
  loadingVoyageId,
  onDoubleConfirmClose,
  onDoubleConfirmConfirm,
  isAddShipModalOpen,
  addShipVoyage,
  onAddShipModalClose,
  isVoyageHistoryModalOpen,
  selectedRow,
  onVoyageHistoryClose,
  handleShipmentHistoryClick,
  isShipmentHistoryModalOpen,
  selectedShipmentRow,
  onShipmentHistoryClose,
  readOnly = false,
}) => {
  return (
    <>
      <ExpSnackbarAlerts
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={onSnackbarClose}
      />
      <GroupEditModal
        open={openEditDialog}
        onClose={onCloseEditDialog}
        mode={vesselFormMode}
        readOnly={readOnly}
        voyageRow={vesselFormMode === 'group-edit' ? editVoyageRow : null}
        setSnackbarMessage={setSnackbarMessage}
        setSnackbarOpen={setSnackbarOpen}
        setSnackbarSeverity={setSnackbarSeverity}
      />
      <DoubleConfirmModal
        title={`Confirm Cancel Voyage (${rowData?.voyageNumber})`}
        open={isDoubleConfirmModalOpen}
        onClose={onDoubleConfirmClose}
        isLoading={!!loadingVoyageId}
        isDisabled={!!loadingVoyageId}
        onConfirm={onDoubleConfirmConfirm}
        onCancel={onDoubleConfirmClose}
      >
        <Stack direction='column' spacing={2}>
          <Alert severity='warning'>
            This will cancel the voyage. You can restore it later if needed.
          </Alert>
        </Stack>
      </DoubleConfirmModal>
      <AddShipModal
        open={isAddShipModalOpen}
        voyage={addShipVoyage}
        onClose={onAddShipModalClose}
        setSnackbarOpen={setSnackbarOpen}
        setSnackbarMessage={setSnackbarMessage}
        setSnackbarSeverity={setSnackbarSeverity}
      />
      <VoyageHistoryModal
        open={isVoyageHistoryModalOpen}
        onClose={onVoyageHistoryClose}
        selectedVoyage={selectedRow}
        handleShipmentHistoryClick={handleShipmentHistoryClick}
      />
      {selectedShipmentRow && (
        <ShipmentHistoryModal
          open={isShipmentHistoryModalOpen}
          onClose={onShipmentHistoryClose}
          selectedShipmentRow={selectedShipmentRow}
        />
      )}
    </>
  );
};

export default VesselSalesModals;
